export interface CropSettings {
    height: number;
    width: number;
    top: number;
    left: number;
    ratio: CropRatioType;
    customRatioValues: {
        x: number;
        y: number;
    };
    preview?: {
        width: number;
        height: number;
        id: string;
    };
    cropBox: CropBox | null;
}

export type CropRatioType = (typeof cropRatioKeys)[number];

export const cropRatioKeys = [
    "freeform",
    "original",
    "custom",
    "1:1",
    "4:3",
    "14:9",
    "16:9",
    "16:10",
    "2:1",
    "3:1",
    "4:1",
    "3:2",
    "5:4",
    "7:5",
    "19:10",
    "21:9",
    "32:9",
    "180:180",
    "820:312",
    "1200:900",
    "1280:720",
    "110:110",
    "320:320",
    "1080:1920",
    "400:400",
    "1500:1500",
    "1024:512",
    "1200:628",
    "1200:675",
    "800:800",
    "2560:1440",
    "5120:2880",
    "1024:768",
    "1280:800",
    "1366:768",
    "1440:900",
    "1920:1080",
    "3840:2160",
    "2480:3508",
    "1748:2480",
    "1280:1748",
    "2400:3300",
] as const;

export interface CanvasImage {
    src: string;
    originalWidth: number;
    originalHeight: number;
    initialWidth: number;
    initialHeight: number;
    containerWidth: number;
    containerHeight: number;
    width: number;
    height: number;
    ratio: number;
    title: string;
    ext: string;
}

export interface CropBox {
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
}

export type Orientation = "landscape" | "portrait";
